import * as random from 'random';
import { ApiService } from '../api.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LabelService } from '../label.service';
import { QuizGameService } from './quiz-game.service';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-quiz-game',
  templateUrl: './quiz-game.component.html',
  styleUrls: ['./quiz-game.component.scss'],
})
export class GuizGameComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();

  @Input() lang = 'tc';
  @Input() csvpath = '';
  @Input() labelpath = '';
  @Input() imgpath = '/assets/img';

  quizListSource: any[] = [];
  quizList: any[] = [];
  userSelectAns = null;
  userResult: boolean[] = [];

  quizNum = 0;
  showAns = false;
  showResult = false;

  label;
  ansLabel = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  uuid = '';

  constructor(private labelService: LabelService, private quizGameService: QuizGameService, private apiService: ApiService) {}

  ngOnInit() {
    this.subs.add(this.labelService.getLabel(this.labelpath).subscribe(res => (this.label = res)));
    this.subs.add(
      this.quizGameService.getQuizList(this.csvpath).subscribe(res => {
        this.quizListSource = res;
        this.randomQuiz();
      }),
    );
  }

  private randomQuiz() {
    this.quizList = [];

    let i = 0;
    do {
      const rand = random.int(0, this.quizListSource.length - 1);
      // console.log(rand);
      if (this.quizList.findIndex(q => q.serial === this.quizListSource[rand].serial) === -1) {
        this.quizList.push(this.quizListSource[rand]);
      }
      i++;
    } while (this.quizList.length < 10 && i < 1000);
    // console.log(this.quizList);
    // this.quizList = res;
    // this.quizList.push(res[0]);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  gameStart() {
    this.quizNum = 1;
    this.userSelectAns = null;

    this.uuid = uuidv4();

    this.apiService
      .gameStart({
        user_token_id: this.uuid,
        game_type: 'quiz',
        lang_id: this.lang,
      })
      .subscribe();
  }

  gameReset() {
    this.quizNum = 0;
    this.userSelectAns = null;
    this.showAns = false;
    this.showResult = false;
    this.userResult = [];
    this.randomQuiz();
  }

  selectAns(ans) {
    if (!this.showAns) {
      this.userSelectAns = ans;
    }
  }

  quizSubmit() {
    if (this.userSelectAns) {
      this.showAns = true;
      const question = this.quizList[this.quizNum - 1];

      let isCorrect = 'N';

      if (this.lang === 'tc') {
        this.userResult.push(question.corrAnsTc === this.userSelectAns);

        if (question.corrAnsTc === this.userSelectAns) {
          isCorrect = 'Y';
        }
      } else if (this.lang === 'sc') {
        this.userResult.push(question.corrAnsSc === this.userSelectAns);

        if (question.corrAnsSc === this.userSelectAns) {
          isCorrect = 'Y';
        }
      } else if (this.lang === 'en') {
        this.userResult.push(question.corrAnsEn === this.userSelectAns);

        if (question.corrAnsEn === this.userSelectAns) {
          isCorrect = 'Y';
        }
      }

      // api
      // console.log(`uuid`, this.uuid);
      // console.log(`question`, question);
      // console.log(`userSelectAns`, this.userSelectAns);
      this.apiService
        .questionResultAdd({
          user_token_id: this.uuid,
          game_type: 'quiz',
          question_id: question.serial,
          question,
          is_answer_correct: isCorrect,
          user_answer_value: this.userSelectAns,
          lang_id: this.lang,
        })
        .subscribe();
    }
  }

  next() {
    if (this.quizNum < this.quizList.length) {
      this.showAns = false;
      this.quizNum++;
      this.userSelectAns = null;
    } else {
      this.showResult = true;

      this.apiService
        .gameResultAdd({
          game_type: 'quiz',
          correct_question_cnt: this.getTrueResultCounter(),
          total_question_cnt: this.userResult.length,
          user_token_id: this.uuid,
          total_score: this.getMark(),
          lang_id: this.lang,
        })
        .subscribe();
    }
  }

  getTrueResultCounter(): number {
    return this.userResult.filter(r => r).length;
  }

  getMark(): number {
    const trueResultCount = this.getTrueResultCounter();
    return trueResultCount * 10;
  }

  getAnsBlockHeightStyle(quiz): string {
    let className = '';

    if (this.lang === 'tc') {
      className = quiz.blockHeightTc;
    } else if (this.lang === 'sc') {
      className = quiz.blockHeightSc;
    } else if (this.lang === 'en') {
      className = quiz.blockHeightEn;
    }
    return className;
  }
}
